import React from 'react';
import utils from 'fantastic/lib/utils';
import styles from "fantastic/components/hoc/styles";
import { compose } from "redux";

const Social = ({socials, size, style}) => {
  return(
    <div className="social" style={style}>
      { socials ?
          socials.map((social, index)=>{
            return(
              <a key={`srv-index--${index}`}><img src={`/social/${social.srv}_${size}.png`}></img></a>
            )
          }) : null
      }
    </div>
  )
};

export default compose(
  styles("padding", "text-align")
)(Social);
